/*!
 * doTERRA Web-UI
 * http://www.doterra.com
 *
 * Copyright 2019 doTERRA Holdings, LLC
 * All Rights Reserved
 */
import React, { useContext, useReducer } from 'react';
import { useSiteState } from './page';
import { getMarketData } from '../data';

const SET_MARKET = 'SET_MARKET';

const MarketStateContext = React.createContext();
const MarketDispatchContext = React.createContext();


const marketInfo = {};

const fetchMarketInfo = (market) => {
    if (!market) {
        return [[], {}];
    }
    // return await fetch(`/market-context/${market}`);     // TODO: restore this when it's ready from OCC
    return getMarketData(market);
};

export const setMarketInfo = (market, info) => {
    marketInfo[market] = info;
};

export const getMarketInfo = (market) => {
    let info = marketInfo[market];
    if (!info) {
        let data = fetchMarketInfo(market);
        info = [data.regions, data.formats];
        setMarketInfo(market, info);
    }
    return info;
};

const MarketReducer = (state, action) => {
    switch (action.type) {
        case SET_MARKET: {
            if (state.market !== action.payload) {
                let [regions, formats] = getMarketInfo(action.payload);
                return {...state, market: action.payload, regions, formats};

            }
            return state;
        }
        default: {
            throw new Error(`[MarketReducer] Unsupported action type: ${action.type}.`);
        }
    }
};


export const MarketProvider = ({children}) => {
    const { site } = useSiteState();
    const [regions, formats] = getMarketInfo(site);
    const [state, dispatch] = useReducer(MarketReducer, {market: site, regions, formats});
    return (
        <MarketStateContext.Provider value={state}> 
            <MarketDispatchContext.Provider value={dispatch}>
                {children}
            </MarketDispatchContext.Provider>
        </MarketStateContext.Provider>
    );
};


export const useMarketState = () => {
    const context = useContext(MarketStateContext);
    if (context === undefined) {
        throw new Error('useMarketState must be used within a MarketProvider.');
    }
    return context;
};


export const useMarketMutator = () => {
    const dispatch = useContext(MarketDispatchContext);
    if (!dispatch) {
        throw new Error('useMarketMutator must be used within a MarketProvider');
    }
    const setMarket = (market) => {
        dispatch({type: SET_MARKET, payload: market});
    };
    return [setMarket];
};
